
import React, { useState } from 'react';
import Bg from '../../../images/shapes/shape_title_under_line.svg'
import shape1 from '../../../images/shapes/shape_line_2.svg'
import shape2 from '../../../images/shapes/shape_line_3.svg'
import shape3 from '../../../images/shapes/shape_line_4.svg'
import shape4 from '../../../images/shapes/shape_space_3.svg'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import TechnologySection from '../TechnologySection/TechnologySection';

const DEFAULT_STEPS = [
    { title: 'Discovery & Site Assessment', body: 'We start by understanding the project, the building, and how the technology will actually be used — walking the site, reviewing drawings, and documenting the real requirements before anything gets specified.' },
    { title: 'Design & Engineering', body: 'We produce the drawings, specifications, and a coordinated scope that fits your budget and works with the other trades — no over-ordering, no redundant infrastructure, no decisions made in the wrong phase.' },
    { title: 'Procurement & Coordination', body: 'We spec and source the right equipment and coordinate with the GC, electrical, and other trades so the install lands on schedule and on budget.' },
    { title: 'Installation & Integration', body: 'We execute the install and integrate the systems so they work together — the network, surveillance, access control, and life-safety all talking to each other as one environment.' },
    { title: 'Testing, Documentation & Handoff', body: 'We validate every system, document the as-built configuration, and train your team so the technology is supportable for its full lifecycle — not a black box after we leave.' },
];

const FaqSection = ({ steps, aiMode = false, hideTech = false }) => {
    const items = steps && steps.length ? steps : DEFAULT_STEPS;
    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    const pad = (i) => String(i + 1).padStart(2, '0');

    return (
        <section className="process_technology_review_section bg-light section_decoration">
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6">
                        <div className="heading_block">
                            <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                                Working Process
                            </div>
                            <h2 className="heading_text mb-0">
                                Our <mark>Approach</mark>
                            </h2>
                        </div>
                        <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                            {items.map((item, i) => (
                                <AccordionItem className="accordion-item" key={i}>
                                    <AccordionHeader targetId={String(i + 1)}>
                                        {pad(i)}. {item.title}
                                    </AccordionHeader>
                                    <AccordionBody accordionId={String(i + 1)} className='acc_body'>
                                        <p className="m-0">{item.body}</p>
                                    </AccordionBody>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                    <div className="col-lg-5">
                        <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                            <ul className="content_layer_group unordered_list_block text-center">
                                {items.map((item, i) => (
                                    <li key={i}><AccordionHeader targetId={String(i + 1)}><span>{item.title}</span></AccordionHeader></li>
                                ))}
                            </ul>
                        </Accordion>
                    </div>
                </div>
                {!hideTech && <TechnologySection aiMode={aiMode} />}
            </div>

            <div className="decoration_item shape_image_1">
                <img src={shape1} alt="BUILDLAB Shape" />
            </div>
            <div className="decoration_item shape_image_2">
                <img src={shape2} alt="BUILDLAB Shape" />
            </div>
            <div className="decoration_item shape_image_3">
                <img src={shape3} alt="BUILDLAB Shape" />
            </div>
            <div className="decoration_item shape_image_4">
                <img src={shape4} alt="BUILDLAB Shape" />
            </div>
        </section>
    )
};
export default FaqSection;
